var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"effect-chart-canvas"},[_c('div',{ref:"chart",staticClass:"effect-chart-canvas__surface"}),(_vm.empty)?_c('div',{staticClass:"effect-chart-canvas__empty"},[_vm._v("暂无数据")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }